import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StatsContext = createContext(null);

const emptyStats = {
  xp: 0, level: 1, xp_into_level: 0, xp_for_next_level: 50,
  streak_days: 0, longest_streak: 0, total_practices: 0,
  achievements: [], achievements_catalog: [],
};

export function StatsProvider({ children }) {
  const { user } = useAuth();
  const [stats, setStats] = useState(emptyStats);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || !user.id) { setStats(emptyStats); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/me/stats");
      setStats(data);
    } catch (err) {
      console.error("stats refresh failed", err);
    }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ stats, loading, refresh, setStats }), [stats, loading, refresh]);
  return <StatsContext.Provider value={value}>{children}</StatsContext.Provider>;
}

export const useStats = () => useContext(StatsContext);

export function rankForMastery(m) {
  if (m >= 95) return { label: "Locked In", tone: "primary" };
  if (m >= 80) return { label: "Stage Ready", tone: "primary" };
  if (m >= 50) return { label: "Rehearsed", tone: "muted" };
  if (m >= 25) return { label: "Getting there", tone: "muted" };
  return { label: "Fresh", tone: "muted" };
}
